











import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component({
	components: {},
})
export default class SaveCancelButtons extends Vue {
	@Prop({ required: false, type: String, default: 'end' })
	public justify?: 'start' | 'end';

	@Prop({ required: false, type: String, default: 'Save' })
	public saveText?: string;

	@Prop({ required: false, type: String, default: 'Cancel' })
	public cancelText?: string;

	@Prop({ required: false, type: Boolean })
	public disableOk?: boolean;

	@Prop({ required: false, type: Boolean })
	public spinning?: boolean;

	@Prop({ required: false, type: Object })
	public cancelLink?: any;

	@Emit('cancel')
	public onCancel(): void {}

	@Emit('submit')
	public onSubmit(): void {}
}
